import { SVGProps } from 'react';

interface LogoProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function Logo({ className, ...props }: LogoProps) {
  return (
    <svg
      width="2350"
      height="655"
      viewBox="0 0 2350 655"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_6704_2)">
        <path
          d="M62.1641 273.257C121.836 228.428 231.169 226.621 289.48 263.351C239.041 252.192 195.332 260.555 160.71 280.873L160.473 280.929C160.549 280.882 160.62 280.837 160.686 280.797V280.869C174.522 272.738 189.509 266.709 205.147 262.985C205.147 262.985 157.308 265.791 120.084 290.601L119.649 290.706C119.223 290.965 118.69 291.397 118.064 291.974C102.947 302.492 89.7991 316.778 82.666 336.162C74.7636 315.551 67.9201 294.556 62.1641 273.257Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M160.722 280.87C174.559 272.739 189.546 266.712 205.184 262.987V262.987C205.184 262.987 107.343 268.723 82.634 336.352V336.593C78.9167 349.125 89.9229 381.927 89.9229 381.927L118.179 412.656C96.1913 323.241 154.357 284.678 160.722 280.798V280.87Z"
          fill="url(#paint0_linear_6704_2)"
        />
        <path
          d="M343.686 162.536H343.651L343.686 162.57V162.536Z"
          fill="url(#paint1_linear_6704_2)"
        />
        <path
          d="M295.663 591.947C277.102 588.566 259.288 581.966 243.037 572.449C213.419 554.676 189.603 528.8 174.449 497.928C98.8144 347.222 236.453 238.357 380.603 300.297H380.846C380.846 300.297 360.753 305.118 347.365 314.975C376.205 309.89 402.567 313.577 425.114 319.554C425.114 319.554 438.428 289.066 440.906 281.113C443.384 273.159 437.262 257.759 432.718 249.564C432.472 253.467 431.603 257.307 430.143 260.94L403.417 243.659C410.001 217.919 356.963 218.883 343.502 162.462C343.502 164.39 342.385 191.673 358.955 204.808L343.745 196.348L343.527 195.77C342.361 195.336 297.364 178.417 268.208 157.208C288.083 181.141 315.076 186.539 311.942 206.567L338.668 223.848C340.128 220.207 340.997 216.359 341.243 212.448C345.786 220.667 351.885 236.067 349.406 244.021C346.928 251.974 333.638 282.462 333.638 282.462C310.994 276.485 284.633 272.822 255.89 277.859C269.277 267.953 289.346 263.205 289.346 263.205C239.028 252.047 195.319 260.41 160.576 280.727V280.414C154.21 284.342 96.0446 322.952 118.033 412.296L150.93 469.633C165.508 499.711 202.39 553.987 217.356 568.761C244.276 595.49 286.746 622.218 286.746 622.218"
          fill="white"
        />
        <path
          d="M359.139 204.905C342.569 191.77 343.589 164.487 343.686 162.559C339.751 172.072 339.338 182.659 342.52 192.445C342.884 193.577 343.297 194.734 343.783 195.915L344.002 196.494L359.139 204.905Z"
          fill="url(#paint2_linear_6704_2)"
        />
        <path
          d="M222.042 425.867V425.626V425.433C194.612 357.13 247.991 268.775 380.77 300.299C236.62 238.407 88.8989 346.116 164.582 496.773C179.736 527.645 211.497 560.945 241.115 578.717C257.366 588.234 276.345 597.998 295.83 591.949C319.276 572.18 341.248 550.754 361.576 527.84C346.892 527.647 332.306 525.441 318.232 521.284C247.286 500.123 223.67 430.952 222.042 425.867Z"
          fill="url(#paint3_linear_6704_2)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.412109 129.083C3.2692 232.13 30.0095 333.14 78.5602 424.283C127.111 515.427 196.168 594.256 280.378 654.659C364.573 594.243 433.618 515.41 482.163 424.269C530.708 333.128 557.451 232.125 560.32 129.083C504.786 99.7631 444.925 79.3458 382.957 68.5889C433.445 93.9916 483.252 125.155 518.701 153.184L518.385 158.005C511.895 243.691 487.837 327.16 447.684 403.299C407.532 479.437 352.13 546.641 284.873 600.793L280.5 604.336L276.126 600.793C208.843 546.642 153.418 479.43 113.248 403.278C73.0778 327.126 49.0092 243.638 42.5176 157.932L42.2017 153.112C65.9621 125.188 93.5566 100.712 124.177 80.3985C81.3044 92.0603 39.8625 108.388 0.606447 129.083H0.412109Z"
          fill="white"
        />
        <path
          d="M320.693 11.1304C320.693 11.1304 318.968 40.0519 336.145 53.5969L320.96 45.1373C320.95 45.0734 320.95 45.0084 320.96 44.9445C298.389 34.5327 268.699 16.7701 250.039 -0.341797C250.039 0.646355 249.918 1.63452 249.918 2.62267C249.918 1.63452 249.918 0.646355 250.039 -0.341797C250.039 -0.341797 264.617 38.2202 307.549 52.0303L266.804 46.2942C266.804 46.2942 231.04 37.2803 196.563 48.9212C196.563 48.9212 209.975 48.4392 246.565 56.7059C246.565 56.7059 218.065 59.9114 207.059 62.2733C205.893 62.2733 160.629 64.1532 131.911 82.1087L132.081 82.2533C154.19 77.433 184.464 80.1323 184.464 80.1323C171.83 83.5065 142.407 94.9787 142.407 94.9787V94.8341C140.73 95.3403 103.751 106.885 79.5279 134.167C91.9964 128.833 104.823 124.363 117.916 120.791C108.749 127.454 100.129 134.828 92.1377 142.844V142.844C92.1377 142.844 67.3554 167.258 47.6025 212.087L50.0322 218.329C57.5884 214.403 65.4638 211.114 73.5753 208.496C70.7245 203.774 67.1878 199.494 63.0793 195.794C80.8884 184.66 105.039 179.743 121.123 177.574C125.132 174.682 129.238 171.91 133.393 169.235L127.853 162.679C136.275 159.876 145.001 158.072 153.85 157.305C164.656 151.598 175.861 146.669 187.379 142.555C183.216 133.453 181.118 123.555 181.232 113.561C190.394 121.749 200.227 129.166 210.631 135.734C223.646 132.519 236.923 130.454 250.306 129.564C250.303 129.62 250.303 129.677 250.306 129.733C250.729 128.079 251.298 126.466 252.007 124.913C252.396 126.455 252.858 127.949 253.295 129.419C289.232 127.555 325.087 134.387 357.769 149.327H358.279H358.109H357.963C355.801 149.857 337.312 154.605 324.726 163.932C353.566 158.847 379.903 162.535 402.474 168.512C402.474 168.512 415.789 138.024 418.267 129.95C420.745 121.876 414.622 106.596 410.079 98.4011C409.872 102.303 409.052 106.15 407.649 109.801L380.923 92.4963C387.775 64.1532 332.987 65.6234 320.839 10.6966"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M249.905 -0.27002C249.905 0.224061 249.874 0.718141 249.844 1.21222C249.813 1.7063 249.783 2.20036 249.783 2.69444C249.783 15.7091 255.42 30.3627 263.025 41.4975C264.215 43.2087 265.454 44.8476 266.669 46.3177L307.414 52.0539C264.531 38.1715 249.905 -0.27002 249.905 -0.27002ZM336.156 53.5963C318.979 39.9791 320.704 11.1298 320.704 11.1298C318.334 16.6955 317.231 22.7109 317.473 28.7479C317.63 34.3211 318.816 39.8186 320.971 44.968C320.969 44.9829 320.967 44.9979 320.966 45.013C320.965 45.0214 320.965 45.0299 320.964 45.0384C320.964 45.0539 320.963 45.0694 320.964 45.085C320.965 45.1103 320.967 45.1357 320.971 45.1608L336.156 53.5963ZM79.3203 134.07C91.8624 128.759 104.763 124.322 117.927 120.791C108.76 127.453 100.14 134.827 92.1488 142.843C88.635 138.951 84.2377 135.943 79.3203 134.07ZM184.28 80.1317C184.28 80.1317 154.007 77.4083 131.825 82.2285C135.875 85.8837 139.355 90.1155 142.151 94.7853V94.9299C142.151 94.9299 171.646 83.5059 184.28 80.1317ZM196.432 48.9928C196.688 48.9852 210.159 48.5831 246.43 56.7777C246.43 56.7777 217.931 59.9831 206.924 62.2727C203.709 57.6326 200.204 53.1973 196.428 48.9929L196.432 48.9928Z"
          fill="url(#paint4_linear_6704_2)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M361.267 529.381C392.796 493.854 420.203 454.927 442.975 413.333L442.149 412.417C374.654 513.161 248.216 493.325 221.709 427.264C221.709 427.264 244.329 501.038 317.801 522.994C331.917 527.149 346.544 529.354 361.267 529.55V529.381Z"
          fill="url(#paint5_linear_6704_2)"
        />
        <path
          d="M210.642 135.685H210.812C215.307 138.601 219.753 141.276 223.932 143.735L224.126 143.855L228.986 146.579H229.131L231.415 147.856L232.144 148.266L235.4 150.049L236.858 150.82L238.631 151.784L240.648 152.845L241.595 153.327L244.025 154.532L244.584 154.821L244.63 154.845C245.366 155.221 246.055 155.575 246.722 155.882C248.034 155.351 249.394 154.869 250.755 154.387L250.755 154.387C250.366 153.158 250.075 151.977 249.807 150.772L249.589 149.591C249.443 148.82 249.297 148.073 249.2 147.326C249.161 147.025 249.134 146.826 249.112 146.668L249.11 146.655L249.11 146.651C249.078 146.424 249.058 146.278 249.03 146.024C248.981 145.59 248.909 144.626 248.86 143.951C248.827 143.5 248.838 143.297 248.849 143.096L248.849 143.095C248.855 142.996 248.86 142.897 248.86 142.771V139.975V138.673V137.203C248.86 136.745 248.86 136.287 249.006 135.853C249.076 135.645 249.078 135.448 249.081 135.254V135.254C249.084 135.044 249.087 134.837 249.176 134.624C249.293 134.341 249.306 134.057 249.319 133.774L249.319 133.773C249.322 133.714 249.325 133.656 249.328 133.597C249.333 133.529 249.338 133.462 249.346 133.395C249.384 133.074 249.467 132.737 249.548 132.409C249.57 132.319 249.592 132.23 249.613 132.142C249.662 131.934 249.705 131.727 249.745 131.522C249.772 131.387 249.797 131.253 249.821 131.121L249.856 130.937C249.911 130.646 250.035 130.19 250.145 129.787L250.151 129.767C250.184 129.643 250.217 129.525 250.245 129.418C250.242 129.362 250.242 129.306 250.245 129.25C236.878 130.231 223.626 132.385 210.642 135.685Z"
          fill="url(#paint7_linear_6704_2)"
        />
        <path
          d="M153.691 157.4L153.717 157.398C164.507 151.702 175.696 146.782 187.196 142.674C189.177 147.245 191.619 151.605 194.485 155.689C195.53 157.159 196.623 158.629 197.838 160.075H197.668C183.237 156.991 168.419 156.088 153.717 157.398L153.667 157.424L153.691 157.4Z"
          fill="url(#paint8_linear_6704_2)"
        />
        <path
          d="M138.287 176.054C138.287 176.054 131.266 176.295 121.037 177.669C125.046 174.777 129.152 172.005 133.428 169.33L133.733 169.738L134.208 170.37C135.536 172.137 136.971 174.045 138.287 176.054Z"
          fill="url(#paint9_linear_6704_2)"
        />
        <path
          d="M1248.5 208.5C1352.93 208.5 1427.87 286.34 1427.87 382.551V383.518C1427.87 478.636 1353.68 556.738 1251.08 558.5H1243.96C1141.4 556.746 1068.17 479.594 1068.17 384.484V383.518C1068.17 287.306 1144.07 208.5 1248.5 208.5ZM936.378 214.677C979.407 214.677 1012.28 226.28 1035.01 249.003C1054.34 268.342 1064.01 293.967 1064.01 326.359V327.326C1064.01 381.959 1034.52 416.285 991.493 432.239L1074.17 553.108H987.143L914.621 444.81H856.121V553.108H781.666V214.677H936.378ZM1821.3 362.619L1957.64 214.677H2049.01L1910.74 358.269L2054.82 553.108H1965.37L1860.46 409.033L1821.3 449.645V553.108H1746.84V214.677H1821.3V362.619ZM645.129 214.677C684.29 214.677 713.782 224.83 733.604 244.652C749.075 260.123 756.812 279.462 756.812 302.186V303.152C756.811 340.863 736.505 363.586 712.332 376.156C751.493 391.144 775.667 414.352 775.667 459.314V460.281C775.667 522.166 725.385 553.107 648.996 553.107H488V438.694C526.007 368.898 554.853 293.053 566.18 214.677H645.129ZM1509.33 362.619L1645.67 214.677H1737.04L1598.77 358.269L1742.84 553.107H1653.4L1548.49 409.033L1509.33 449.645V553.107H1434.87V214.677H1509.33V362.619ZM2212.53 214.677C2255.56 214.677 2288.43 226.28 2311.16 249.003C2330.5 268.342 2340.17 293.967 2340.17 326.359V327.326C2340.16 381.958 2310.67 416.285 2267.64 432.239L2350.32 553.107H2263.29L2190.77 444.81H2132.27V553.107H2057.82V214.677H2212.53ZM1247.54 277.153C1187.59 277.154 1146.01 324.534 1146.01 382.551V383.518C1146.01 441.534 1188.55 489.882 1248.5 489.882C1308.45 489.882 1350.03 442.501 1350.03 384.484V383.518C1350.03 325.501 1307.49 277.153 1247.54 277.153ZM560.521 487.839H648.996C681.872 487.839 701.695 476.235 701.695 451.095V450.128C701.695 427.405 685.257 413.384 646.579 413.384H560.521V487.839ZM856.121 379.058H931.543C968.287 379.058 988.593 360.202 988.593 331.193V330.227C988.593 297.834 966.836 281.88 930.093 281.88H856.121V379.058ZM2132.27 379.058H2207.69C2244.44 379.058 2264.74 360.202 2264.74 331.193V330.227C2264.74 297.834 2242.99 281.88 2206.24 281.88H2132.27V379.058ZM560.521 351.5H629.174C662.05 351.5 682.84 340.863 682.84 315.723V314.756C682.84 292.033 665.435 279.945 634.009 279.945H560.521V351.5Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6704_2"
          x1="52.6759"
          y1="348.165"
          x2="205.19"
          y2="337.715"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6704_2"
          x1="343.651"
          y1="162.553"
          x2="343.686"
          y2="162.553"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#121331" />
          <stop offset="1" stopColor="#373B97" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6704_2"
          x1="340.401"
          y1="183.705"
          x2="359.14"
          y2="183.705"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6704_2"
          x1="284.367"
          y1="285.007"
          x2="231.761"
          y2="506.073"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.1" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6704_2"
          x1="79.3203"
          y1="71.1953"
          x2="336.17"
          y2="71.1953"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6704_2"
          x1="221.709"
          y1="470.909"
          x2="421.313"
          y2="470.909"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_6704_2"
          x1="121.037"
          y1="153.35"
          x2="432.938"
          y2="148.603"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_6704_2"
          x1="121.037"
          y1="153.35"
          x2="432.938"
          y2="148.603"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_6704_2"
          x1="121.037"
          y1="153.35"
          x2="432.938"
          y2="148.603"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_6704_2"
          x1="121.037"
          y1="153.35"
          x2="432.938"
          y2="148.603"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_6704_2">
          <rect width="2350" height="655" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
